/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Avoid_Duplicates_HelpInputs */

const en_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When enabled, the AI will skip scenes whose content has already been adequately described in a previous scene.`)
};

const fr_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsqu'elle est activée, l'IA ignorera les scènes dont le contenu a déjà été correctement décrit dans une scène précédente.`)
};

const de_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn diese Funktion aktiviert ist, überspringt die KI Szenen, deren Inhalt bereits in einer vorherigen Szene ausreichend beschrieben wurde.`)
};

const it_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando attivata, l'IA salterà le scene il cui contenuto è già stato descritto in modo adeguato in una scena precedente.`)
};

const ru_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При включении этой функции ИИ будет пропускать сцены, содержание которых уже было достаточно подробно описано в предыдущей сцене.`)
};

const es_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando está activada, la IA omitirá las escenas cuyo contenido ya haya sido descrito adecuadamente en una escena anterior.`)
};

const zh_cn2_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用此功能后，人工智能将跳过前面场景中已经充分描述过内容的场景。`)
};

const ja_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効にすると、AIは前のシーンで既に十分に説明されている内容のシーンをスキップします。`)
};

const hi_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब एआई को सक्षम किया जाता है, तो यह उन दृश्यों को छोड़ देगा जिनकी सामग्री का वर्णन पिछले दृश्य में पहले ही पर्याप्त रूप से किया जा चुका है।`)
};

const pt_pt2_sd_avoid_duplicates_help = /** @type {(inputs: Sd_Avoid_Duplicates_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando ativada, a IA irá ignorar cenas cujo conteúdo já foi adequadamente descrito em uma cena anterior.`)
};

/**
* | output |
* | --- |
* | "When enabled, the AI will skip scenes whose content has already been adequately described in a previous scene." |
*
* @param {Sd_Avoid_Duplicates_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_avoid_duplicates_help = /** @type {((inputs?: Sd_Avoid_Duplicates_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Avoid_Duplicates_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sd_avoid_duplicates_help(inputs)
	if (locale === "de") return de_sd_avoid_duplicates_help(inputs)
	if (locale === "it") return it_sd_avoid_duplicates_help(inputs)
	if (locale === "ru") return ru_sd_avoid_duplicates_help(inputs)
	if (locale === "es") return es_sd_avoid_duplicates_help(inputs)
	if (locale === "zh-CN") return zh_cn2_sd_avoid_duplicates_help(inputs)
	if (locale === "ja") return ja_sd_avoid_duplicates_help(inputs)
	if (locale === "hi") return hi_sd_avoid_duplicates_help(inputs)
	if (locale === "pt-PT") return pt_pt2_sd_avoid_duplicates_help(inputs)
	return en_sd_avoid_duplicates_help(inputs)
});